var map = {
	"./Emr Theme.pdf": 1837,
	"./OIP.jpg": 8956,
	"./apollo-fotter.jpeg": 1890,
	"./apollo-gleneagles.png": 396,
	"./apollo.png": 9066,
	"./back.png": 584,
	"./camera.png": 2018,
	"./cameraSwitch.png": 6708,
	"./chi.jpeg": 8682,
	"./clinicImage.avif": 7551,
	"./clinicImage.jpg": 2719,
	"./clinicImage2.jpg": 4550,
	"./clinicImage3.jpg": 927,
	"./cliniclogo.jpeg": 3086,
	"./consultation.png": 6124,
	"./create.png": 7595,
	"./cross.png": 6974,
	"./dashboard.png": 6948,
	"./defaultClinicLogo.png": 5850,
	"./delete-icon.jpg": 6956,
	"./doctor-appointment.jpg": 7190,
	"./doctorImage.jpg": 9859,
	"./doctorlogo.png": 7370,
	"./doctors.png": 9378,
	"./doctorslist.png": 9939,
	"./documents.png": 2771,
	"./edit.png": 3269,
	"./enterconsultation.png": 2565,
	"./feedback.jpg": 9470,
	"./feedback2.jpg": 1602,
	"./home_guide_line.png": 975,
	"./indiarupee.png": 264,
	"./ledger.jpg": 251,
	"./loginimage2.jpg": 4914,
	"./logout-vector.jpg": 4955,
	"./logout.png": 8763,
	"./logoutblue.jpg": 5168,
	"./mainlogo.jpeg": 9953,
	"./newdoctorlogo.jpg": 5032,
	"./patientcheckout.png": 7975,
	"./patientscheckin.jpg": 2012,
	"./patientsinfo.png": 9509,
	"./payment.jpg": 4510,
	"./pdf.png": 1509,
	"./phone-call.png": 29,
	"./plus.png": 5845,
	"./poweroff.jpg": 3837,
	"./print.jpeg": 2716,
	"./receipt.png": 6647,
	"./remove.png": 1687,
	"./rupee.jpg": 3393,
	"./save.png": 9908,
	"./schedule.png": 189,
	"./search.png": 2722,
	"./select.jpg": 120,
	"./signout_icon.png": 2095,
	"./staff_logo.png": 2489,
	"./tickmark.png": 420,
	"./upload.png": 5315,
	"./user.png": 8791,
	"./userfeedback.png": 863,
	"./view.png": 2032,
	"./whatsapp.png": 2409,
	"./workflow.jpg": 6024,
	"./workflow.png": 6718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 787;